import { Directory, Filesystem } from '@capacitor/filesystem';
import { Toast } from 'antd-mobile';
import { getPlatform, isNative } from './updateManagerRemote';

// 处理图片并转换为 JPG Base64
const convertToJpgBase64 = (img, resolve, reject) => {
  // // 设定最大宽度和最大高度
  // const maxWidth = 1280;
  // const maxHeight = 1920;

  // // 获取图片的自然宽高（原始尺寸）
  // const naturalWidth = img.width;
  // const naturalHeight = img.height;

  // // 计算缩放比例
  // const widthRatio = maxWidth / naturalWidth;
  // const heightRatio = maxHeight / naturalHeight;

  // // 获取较小的缩放比例，确保图片不会超出最大宽高
  // const scaleRatio = Math.min(widthRatio, heightRatio);

  // // 根据缩放比例调整宽高
  // const newWidth = naturalWidth * scaleRatio;
  // const newHeight = naturalHeight * scaleRatio;

  // console.log('缩放前', img, img.width, img.height);

  // // 设置图片的新宽高
  // img.style.width = `${newWidth}px`;
  // img.style.height = `${newHeight}px`;
  // console.log('缩放后', img, img.width, img.height);

  try {
    // 创建 canvas 元素
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // 设置 canvas 尺寸为图片的宽高
    canvas.width = img.width;
    canvas.height = img.height;

    // 将图片绘制到 canvas 上
    ctx.drawImage(img, 0, 0);

    // 转换为 JPG 格式的 Base64
    const jpgBase64 = canvas.toDataURL('image/jpeg');
    resolve(jpgBase64);
  } catch (error) {
    reject('画布绘画失败: ' + error);
  }
};

// 转换图片（avif=>jpg, 可以是image元素、远程url，base64）
const convertImageToJpgBase64 = (data: { imgSrc?: string; imgElement?: any }) => {
  return new Promise((resolve, reject) => {
    // 如果image不存在，使用imageSrc创建一个
    if (data.imgElement) {
      console.log('本地图片');

      const img = data.imgElement;
      img.crossOrigin = 'Anonymous';
      img.setAttribute('crossOrigin', 'Anonymous');
      convertToJpgBase64(data.imgElement, resolve, reject);
    } else {
      console.log('远程图片');
      const img = new Image();

      // 允许跨域图片（需要目标服务器支持 CORS）
      img.crossOrigin = 'Anonymous';
      img.setAttribute('crossOrigin', 'Anonymous');
      img.src = data.imgSrc; // 兼容 远程图片url，Base64 URL

      img.onload = () => {
        convertToJpgBase64(img, resolve, reject);
      };

      img.onerror = (error) => {
        reject('图片加载失败: ' + error);
      };
    }
  });
};

// 下载图片
// 有些问题，先不用
const doDownloadImg = async (data: { imageElement: any; filename: string }) => {
  convertImageToJpgBase64({ imgElement: data.imageElement }) // 保存已渲染图片(由于是远程图片会污染画布，跨域先不解决)
    .then((dataurl: string) => {
      // 创建一个 <a> 标签，用于下载 JPG 文件
      const link = document.createElement('a');
      link.href = dataurl;
      link.download = data.filename.replace('avif', 'jpg');

      // 触发点击事件，下载文件
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(dataurl);
      link.remove();

      Toast.show('已保存到本地相册');
    })
    .catch((err) => {
      console.error('图片保存失败:', err);
      Toast.show('图片保存失败');
    });
};

const isBase64Img = (imageUrl: string) => {
  return imageUrl.startsWith('data:image') && imageUrl.includes('base64');
};

// 下载图片(base64图片/图片url)
export const downloadImageStrong = async (data: { imageUrl: string; imageName: string }) => {
  const filename = data.imageName.replace('avif', 'jpg');
  if (isBase64Img(data.imageUrl)) {
    console.log('base64图片，直接保存:' + JSON.stringify(data, null, 2));
    saveImg(data.imageUrl, filename);
    return;
  }
  console.log('图片url，下载保存:' + JSON.stringify(data, null, 2));
  convertImageToJpgBase64({ imgSrc: data.imageUrl }) // 下载远程图片并转为base64
    .then((dataurl: string) => {
      saveImg(dataurl, filename);
    })
    .catch((err) => {
      console.error('图片保存失败:', err);
      Toast.show('图片保存失败');
    });
};

const saveImg = async (base64Url, imageName) => {
  if (isNative()) {
    // 文件系统保存文件
    await Filesystem.writeFile({
      path: '/output/image/' + imageName,
      data: base64Url,
      directory: Directory.Documents,
      recursive: true,
    });
  } else {
    // 浏览器API保存文件
    // 创建一个 <a> 标签，用于下载 JPG 文件
    const link = document.createElement('a');
    link.href = base64Url;
    link.download = imageName;

    // 触发点击事件，下载文件
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(base64Url);
    link.remove();
  }

  Toast.show('已保存到相册');
};

export default { downloadImageStrong };
